import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
//import { map } from 'rxjs/operators';
import { UrlService } from '@core/services/url/url.service';

import { User } from '@core/objects/user';
import { UserRequest } from '@core/objects/user-request';
import { SeatSetting } from '@core/objects/seat';

@Injectable({
  providedIn: 'root'
})
export class SettingsUsersRequests {
    private readonly usersPrefix = "/users";

    constructor(private http: HttpClient, private urlSrv : UrlService) {
	}

	public loadAllUsers$ = () : Observable <User[]> =>
		this.http.get<User[]>(this.urlSrv.build(this.usersPrefix));

	public loadAllSeats$ = () : Observable <SeatSetting[]> => 
		this.http.get<SeatSetting[]>(this.urlSrv.build(this.usersPrefix + "/seats"));

	public loadOneUser$ = ( user: User ) : Observable <User> =>
		this.http.get<User>(this.urlSrv.build(this.usersPrefix + "/" + user.id));

	public addNewInvitation$ = ( name:string, email:string, message:string, groups:Array<number>, extra: any) : Observable<string> => {
		let data = {
			name: name,
			email: email,
			message: message,
			groups: groups
		}

        data = {...data, ...extra};
		return this.http.post(this.urlSrv.build(this.usersPrefix + "/invitations"), data, {responseType: 'text'});
	}

	public deleteOneUser$ = ( id:string ) : Observable <string> => {
		return this.http.delete(this.urlSrv.build(this.usersPrefix + "/" + id), {responseType: 'text'});
	}

	public deleteInvitation$ = ( email:string ) : Observable <string> => {
		return this.http.delete(this.urlSrv.build(this.usersPrefix + "/invitations/" + email), {responseType: 'text'});
	}
}
